<template>
  <el-dialog class="dialog" title="添加分组联络员" width="1100px" :visible.sync="addDialogInfo.flag"
    :close-on-click-modal="false" :close-on-press-escape="false" distroy-on-close>
    <div class="main-contant">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="groupForm" size="small">
        <el-form-item label="班组名称：" prop="groupId">
          <el-select v-model="ruleForm.groupId" placeholder="请选择班组名称">
            <el-option v-for="(item, i) in groupList" :key="i" :label="item.paramValue"
              :value="item.paramKey"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btm-table">
        <div class="left-tree">
          <LeftLazyTree @select="select" @clearCheckedNodes="clearCheckedNodes" />
        </div>
        <div class="right-table">
          <search ref="search" @search="searchHandle" />
          <el-table ref="pageListTable" border :height="375" :data="tableData" :row-key="getRowKeys"
            :row-style="{ color: '#51627D', fontWeight: 400 }" :header-cell-style="{
              background: '#DCE7FA',
              color: '#343C4A',
              fontWeight: 500,
            }" @selection-change="handleSelectionChanges">
            <el-table-column type="selection" :selectable="selectInit" :reserve-selection="true" width="40">
            </el-table-column>
            <el-table-column prop="userName" label="姓名" show-overflow-tooltip width="100">
            </el-table-column>
            <el-table-column prop="deptName" label="工作单位" show-overflow-tooltip width="200">
            </el-table-column>
            <el-table-column prop="unitPosition" label="单位及职务" show-overflow-tooltip></el-table-column>
          </el-table>
          <el-pagination class="pagination" @size-change="sizeChange" @current-change="pageChange"
            :current-page="currentPage" :page-size="size" :page-sizes="[10, 50, 100, 500, 1000]"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>

    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Search from "./addLiaisonSearch.vue";
import LeftLazyTree from "@/components/tree/leftLazyTree.vue";
import { pageByDeptOrPermission } from "@/api/classOffline.js";

import { saveLiaisons, groupNames } from "@/api/groupManage.js"

export default {
  components: {
    Search,
    LeftLazyTree
  },
  props: {
    classId: {
      type: String,
      default: () => "",
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => [],
    },
    addDialogInfo: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      props: {
        //树形
        label: "deptName",
        children: "zones",
        isLeaf: function (data, node) {
          return !data.hasChildren
        }
      },
      ruleForm: {},
      rules: {
        groupId: [
          { required: true, message: "请选择班组名称", trigger: "change" },
        ]
      },
      groupList: [],
      deptName: "",
      treeData: [],
      getRowKeys(row) {
        return row.uuid;
      },
      selectedMembers: [],
      tableData: [],
      total: 0,
      currentPage: 1,
      size: 10,
      userIdList: new Set(),
      nowPageIds: [],
      hasIds: [],
      originListSet: [],
      deptLevelCodes: []
    };
  },
  created() {
    if (this.defaultCheckedKeys) {
      this.selectedMembers = this.defaultCheckedKeys;
      this.originListSet = this.selectedMembers;
      this.hasIds = this.selectedMembers.map((x) => x.uuid);
      this.selectedMembers.map((x) => {
        this.userIdList.add(x.uuid);
      });
    }
    this.getGroupData();
  },
  methods: {

    getGroupData() {
      groupNames({ classId: this.classId, excludeNoGroup: 1 }).then(({ code, data }) => {
        if (code !== 0) return;
        this.groupList = [...data];
      });
    },

    select(obj) {
      this.currentPage = 1;
      this.deptLevelCodes = obj.deptLevelCodes;
      this.getList(this.$refs.search.filters);
    },
    clearCheckedNodes() {
      this.deptLevelCodes = null;
    },
    handleSelectionChanges(rows) {
      // 求差集
      let arr = [...rows].filter(x => [...this.originListSet].every(y => y.uuid !== x.uuid));
      this.selectedMembers = arr;
      this.selectedMembers = this.selectedMembers.map(item => {
        return {
          ...item,
          roomNumber: null
        }
      });
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList(this.$refs.search.filters);
    },
    sizeChange(size) {
      this.size = size;
      this.getList(this.$refs.search.filters);
    },
    selectInit(row) {
      if (this.hasIds.length > 0) {
        return !this.hasIds.includes(row.uuid);
      }
      return true;
    },
    // 历史选中回显置灰
    getList(param) {
      let params = {
        page: this.currentPage,
        limit: this.size,
        deptLevelCodes: this.deptLevelCodes,
        classId: this.classId,
      };
      pageByDeptOrPermission({
        ...params,
        ...param,
      }).then(({ code, data }) => {
        if (code !== 0) return;
        this.handleData(data);
      });
    },
    handleData(data) {
      let { records, total } = data;
      this.tableData = records;
      this.total = total;
      this.nowPageIds = this.tableData.map((x) => x.uuid);
      let rows = [];
      this.selectedMembers.map((x) => {
        this.userIdList.add(x.uuid);
      });
      this.nowPageIds.forEach((x, i) => {
        if (Array.from(this.userIdList).includes(x)) {
          rows.push(this.tableData[i]);
        }
      });
      setTimeout(() => {
        rows.forEach((row) => {
          this.$refs.pageListTable.toggleRowSelection(row, true);
        });
      }, 200);
    },
    // 条件筛选
    searchHandle(data) {
      this.currentPage = 1;
      this.getList(data);
    },
    confirm() {
      // 保存
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.selectedMembers || !this.selectedMembers.length) {
            this.$message.warning('请选择至少选择一个联络员')
          } else {
            const userList = this.selectedMembers.map(item => {
              return {
                uuid: item.uuid,
                userMobile: item.userMobile,
                unitPosition: item.unitPosition,
                userName: item.userName,
              }
            })
            let params = {
              classId: this.classId,
              groupId: this.ruleForm.groupId,
              userList
            }
            saveLiaisons(params).then(({ code }) => {
              if (code === 0) {
                this.$message({type: 'success', message: '添加成功'})
                this.close(true)
              }
            })
          }
        }
      })
    },
    close(flag = false) {
      this.$emit("close", flag);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-contant {

  .groupForm {
    margin-bottom: 18px;
    border-bottom: 1px solid #ebebeb;
  }

  .btm-table {
    display: flex;
    height: 500px;
  }
}



.left-tree {
  width: 350px;
  margin-right: 10px;

  // height: 470px;
  // overflow-y: scroll;
  /deep/ .tree-dept {
    max-height: 420px;
    overflow-y: auto;
  }
}

.right-table {
  flex: 1;
}

.top-filter {
  margin-bottom: 10px;
}

.pagination {
  margin-top: 16px;
  float: right;
}

.name-input {
  width: 250px;
  margin-right: 10px;
}

$text-color: #51627d;
$text-font: 14px;

@mixin text {
  color: $text-color;
  font-size: $text-font;
}

@mixin border {
  border: 1px solid #d7dbe0;
  border-radius: 2px;
}

@mixin panel {
  width: 48%;
  height: 300px;
  box-sizing: border-box;
  overflow: hidden;
}

.dialog {
  /deep/ .el-dialog__body {
    max-height: 570px !important;
    height: 570px !important;
    padding: 24px 38px;

    .left-panel {
      float: left;
      @include border;
      padding: 10px;
      @include panel;
    }

    .right-panel {
      float: right;
      @include border;
      @include panel;
    }
  }
}
</style>